/* eslint-disable */
import GECStore from "../flux/GECStore.ts";
import React from "react";

class GBETHelper {
    //static ScreenWidthType = {
    //"Mobile": 1,
    //"Tablet": 2,
    //"Desktop": 3
    //};
    //static ScreenOrientationType = {
    //"Portrait": 1,
    //"Landscape": 2
    //};

    //static screenWidthType = this.ScreenWidthType.Mobile; // Mobile / Tablet / Desktop
    //static screenHeightType = undefined;
    //static screenOrientationType = this.ScreenOrientationType.Portrait;


    //static calculateScreenDimensions() {
    //if (screen.width < 300) {
    //screenWidthType = this.ScreenWidthType.Mobile;
    //} if (screen.width < 1000) {
    //screenWidthType = this.ScreenWidthType.Tablet;
    //} else {
    //screenWidthType = this.ScreenWidthType.Desktop;
    //}

    //screenOrientationType = (screen.orientation.angle === 0) ? ScreenOrientationType.Portrait : ScreenOrientationType.Landscape;

    //}

    static toTitleCase(words) {
        const wordsArr = words.split(" ");
        let titleCaseString = "";

        wordsArr.forEach((word, i) => {
            wordsArr[i] = word.charAt(0).toUpperCase() + word.slice(1);
            titleCaseString += (wordsArr[i] + " ");
        });

        return titleCaseString.trim();
    }

    static getEventIdFromUrl() {
        const urlParts = window.location.pathname.replace(configurationSettings?.webRoot, "").trimEnd().split("/");
        const lastParts = urlParts[urlParts.length - 1].split("-");
        const eventId = +lastParts[lastParts.length - 1];

        if (eventId && !isNaN(eventId)) {
            return eventId;
        }

        return undefined;
    }

    static getBreadCrumbFromEventClassifier(eventClassifier) {
        var breadCrumbs = [];
        var parentEventObjectExists = true;
        var newEventClasifierObject = eventClassifier;
        breadCrumbs.push({ eventClassifierId: newEventClasifierObject.eventClassifierId, eventClassifierName: newEventClasifierObject.eventClassifierName });
        while (parentEventObjectExists) {
            if (newEventClasifierObject.getParent() !== undefined) {
                newEventClasifierObject = newEventClasifierObject.getParent();
                //breadCrumbs.push(newEventClasifierObject);
                breadCrumbs.push({ eventClassifierId: newEventClasifierObject.eventClassifierId, eventClassifierName: newEventClasifierObject.eventClassifierName });
                parentEventObjectExists = true;
            } else {
                parentEventObjectExists = false;
            }
        }

        return breadCrumbs.reverse();
    }

    static getBreadCrumbFromUrl() {
        var parts = window.location.href.replace(configurationSettings.baseUrl, "").split("/");

        const eventIds = parts;
        const eventNames = parts;
        const breadcrumbs = [];
        eventIds.forEach(function (eventId, index) {
            breadcrumbs.push({ eventClassifierId: eventId, eventClassifierName: eventNames[index] });
        });

        return breadcrumbs;
    }

    static getBreadCrumbFromMarket(market) {
        const eventIds = market.ancestryChain.split("~");
        eventIds.pop();
        const eventNames = market.eventClassifierFullName.split("~");
        const breadcrumbs = [];
        eventIds.forEach(function (eventId, index) {
            breadcrumbs.push({ eventClassifierId: eventId, eventClassifierName: eventNames[index] });
        });

        return breadcrumbs;
    }

    static getPageTitle(path, eventClassifier, configurationSettings) {
        let { whitelabelDisplayName: whiteLableDisplayNameAllCaps } = configurationSettings;
        whiteLableDisplayNameAllCaps = whiteLableDisplayNameAllCaps?.toUpperCase();

        const lowerCase = whiteLableDisplayNameAllCaps?.toLowerCase();
        const whiteLableDisplayName = lowerCase?.charAt(0)?.toUpperCase() + lowerCase?.slice(1);

        let mode = "";
        switch (GBEglobal.mode) {
            case ModeTypes.Singles:
                mode = "| Exchange";
                break;
            case ModeTypes.Multiples:
                mode = "| Multiples";
                break;
            case ModeTypes.Sportsbook:
                mode = "| Sportsbook";
                break;
        }

        let pageTitle;
        if (eventClassifier) {
            const eventName = GBEUtils.getEventName(eventClassifier.eventClassifierName);
            const suffix = eventName.length < 13 ? "Betting & Odds" : "Betting";

            switch (eventName) {
                case "American Football":
                    pageTitle = `American Football Betting ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Baseball":
                    pageTitle = `Baseball Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Basketball":
                    pageTitle = `Basketball Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Boxing":
                    pageTitle = `Boxing Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Cricket":
                    pageTitle = `Cricket Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Darts":
                    pageTitle = `Darts Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Formula 1":
                    pageTitle = `Formula 1 Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Golf":
                    pageTitle = `Golf Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Greyhound Racing":
                    pageTitle = `Greyhound Racing Betting ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Soccer":
                    pageTitle = `Soccer Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Horse Racing":
                    pageTitle = `Horse Racing Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Ice Hockey":
                    pageTitle = `Ice Hockey Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "NFL":
                    pageTitle = `NFL Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Politics":
                    pageTitle = `Politics Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Rugby League":
                    pageTitle = `Rugby League Betting ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Rugby Union":
                    pageTitle = `Rugby Union Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Super League":
                    pageTitle = `Super League Betting ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Tennis":
                    pageTitle = `Tennis Betting & Odds ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Virtual Sports":
                    pageTitle = `Virtual Sports Odds & Betting ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Soccer Coupon":
                    pageTitle = `Soccer Betting Coupons ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "Both Teams To Score Coupon":
                    pageTitle = `Both Teams to Score | Soccer Betting Coupons ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                case "O/U 2.5 Goals Coupon":
                    pageTitle = `U/O 2.5 Goals|Soccer Betting Coupons ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                default:
                    pageTitle = `${eventName} ${suffix} ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
            }
            return pageTitle;
        }

        switch (path?.toLowerCase()) {
            case "":
                pageTitle = `${whiteLableDisplayNameAllCaps}: Online Betting, Exchange, Sportsbook & Casino`;
                break;
            case "sportsbook":
                pageTitle = `Sportsbook Betting | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "exchange":
                pageTitle = `Betting Exchange & Odds | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino":
                pageTitle = `Online Casino Games UK | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/100k jackpots":
            case "casino/100k%20jackpots":
                pageTitle = `100K Jackpot Casino Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/150k jackpots":
            case "casino/150k%20jackpots":
                pageTitle = `150K Jackpot Casino Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/250k jackpots":
            case "casino/250k%20jackpots":
                pageTitle = `250K Jackpot Casino Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/all casino games":
            case "casino/all%20casino%20games":
                pageTitle = `All Casino Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/all jackpots":
            case "casino/all%20jackpots":
                pageTitle = `All Online Jackpots | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/all table games":
            case "casino/all%20table%20games":
                pageTitle = `All Online Table Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/arcade":
                pageTitle = `Online Arcade Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/exclusive jackpots":
            case "casino/exclusive%20jackpots":
                pageTitle = `Exclusive Jackpots | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/exclusive slots":
            case "casino/exclusive%20slots":
                pageTitle = `Exclusive Slots | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/exclusive table games":
            case "casino/exclusive%20table%20games":
                pageTitle = `Exclusive Table Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/new games":
            case "casino/new%20games":
                pageTitle = `New Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "pages/safer-gambling":
                pageTitle = `Safer Gambling | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "promotions":
                pageTitle = `Promotions - UP TO €1000 CASH-BACK | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "sportspools":
                pageTitle = `Sports Pools | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "casino/virtual sports":
            case "casino/virtual%20sports":
                pageTitle = `Virtual Sports Games | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "exchange/inplay":
                pageTitle = `In-Play | Betting Exchange & Odds | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "sportsbook/inplay":
                pageTitle = `In-Play | Betting Sportsbook & Odds | ${whiteLableDisplayNameAllCaps}`;
                break;
            case "sportsbook/cashout": // fallthrough
            case "exchange/cashout":
                pageTitle = `Cashout | ${whiteLableDisplayNameAllCaps}`;
                break;
            default:
                if (path.indexOf("virtual-sports") > -1) {
                    pageTitle = `Virtual Sports Odds & Betting ${mode} | ${whiteLableDisplayNameAllCaps}`;
                    break;
                }
                pageTitle = `${whiteLableDisplayName}: Online Betting, Exchange, Sportsbook & Casino`;
                break;
        }

        return pageTitle;
    }

    static getPageDescription(path, eventClassifier, configurationSettings) {
        const { whitelabelDisplayName } = configurationSettings;

        let mode = "";
        switch (GBEglobal.mode) {
            case ModeTypes.Singles:
                mode = "Exchange";
                break;
            case ModeTypes.Multiples:
                mode = "Multiples";
                break;
            case ModeTypes.Sportsbook:
                mode = "Sportsbook";
                break;
        }

        let pageDescription;
        if (eventClassifier) {
            const eventName = GBEUtils.getEventName(eventClassifier.eventClassifierName);
            pageDescription = `Bet on ${eventName} with ${whitelabelDisplayName} ${mode}`;

            return pageDescription;
        }

        pageDescription = this.buildPageSpecificDescription(path, mode, whitelabelDisplayName);
        if (pageDescription) {
            return pageDescription;
        }

        switch (path?.toLowerCase()) {
            case "":
                pageDescription = `Join ${whitelabelDisplayName} for all your online betting! ✓${whitelabelDisplayName} Exchange ✓Sportsbook ✓Casino ✓New Customers Offers.`;
                break;
            case "sportsbook":
                pageDescription = `Sportsbook Betting | ${whitelabelDisplayName}`;
                break;
            case "exchange":
                pageDescription = `Join ${whitelabelDisplayName} Exchange for all your online betting.`;
                break;
            default:
                pageDescription = `${whitelabelDisplayName} : Online Betting, Exchange, Sportsbook & Casino`;
                break;
        }

        return pageDescription;

    }

    static buildPageSpecificDescription(path, mode, whitelabelDisplayName) {
        const parts = path?.split("/");
        let description;

        if (parts?.length > 1) {

            switch (parts[1].toLowerCase()) {
                case "inplay":
                    description = `In-play bets on ${whitelabelDisplayName} ${mode}`;
                    break;
                case "cashout":
                    description = `Cash out on ${whitelabelDisplayName} ${mode}`;
                    break;
                case "safer-gambling":
                    description = `Safer Gambling at ${whitelabelDisplayName} - Deposit Limits, Time Management, Account Closure & Self Exclusion information.`;
                    break;
                default:
                    return undefined;
            }
        }

        return description?.trim() ?? undefined;
    }

    static showMarketingPreferences(params) { //params.type, params.availableFunds


        function savePrefrenceAndClose() {

            const marketingPreference = {
                "email": true, "sms": true, "phone": true,
                "products": { "betting": true, "casino": false },
                "dateUpdated": new Date().toISOString()
            };

            GECStore.getController().addPunterTaggedValue({
                name: "GEP.Preferences.MarketingPreferences",
                value: JSON.stringify(marketingPreference),
                callbackOnException: function (response) {
                    alert("Error Saving Setting - please reload");
                    console.error(response);
                },
                callbackOnSuccess: function () {
                    params.component.setState({
                        modalConfig: {
                            show: false
                        }
                    }, params.component.popDialogQueue);

                }
            });
        }

        function close() {
            const marketingPreference = {
                "email": false, "sms": false, "phone": false,
                "products": { "betting": false, "casino": false },
                "dateUpdated": new Date().toISOString()
            };

            GECStore.getController().addPunterTaggedValue({
                name: "GEP.Preferences.MarketingPreferences",
                value: JSON.stringify(marketingPreference),
                callbackOnException: function (response) {
                    alert("Error Saving Setting - please reload");
                    console.error(response);
                },
                callbackOnSuccess: function () {
                    params.component.setState({
                        modalConfig: {
                            show: false
                        }
                    }, params.component.popDialogQueue);

                }
            });
        }

        function selectAll() {

        }

        params.component.setState({
            modalConfig: {
                show: true,
                removeCloseButton: true,
                content: {
                    title: "",
                    markup: <div>
                        <h1>Let's Keep You Up To Date!</h1>
                        <p>Tick the boxes below and stay tuned to the latest odds, offers, free bets and bonuses, as well as live betting and sporting action on the go.</p>
                        <p>After selecting your preference, click 'Save Changes' to apply the update</p>
                        <p>I want updates on the following BETDAQ products:</p>

                        <input type="checkbox" id="betting" /> <label for="betting">Betting</label>
                        <input type="checkbox" id="casino" /> <label for="casino">Casino</label>

                        <p>Receive comminications via:</p>
                        <input type="checkbox" id="all" onClick={selectAll} /> <label for="all">All</label>
                        <input type="checkbox" id="email" /> <label for="email">Email</label>
                        <input type="checkbox" id="phone" /> <label for="phone">Phone</label>
                        <input type="checkbox" id="sms" /> <label for="sms">SMS</label>
                        <br />

                        <button onClick={savePrefrenceAndClose}>Save Changes</button>
                        <br />
                        <button onClick={close}>No Thanks</button>

                    </div>
                },
                modalDialogClass: "",
                extraClass: ""
            }
        });

    }

    static showDepositFunds(params) { //params.type, params.availableFunds

        var title = "";
        var content = "";

        switch (params.type) {
            case "welcomeLimit":
                title = "Welcome Back";
                content = "Hi " + params.username + ", your available funds are <span class='host-moneyamount'>" +
                    GBEUtils.formatDecimal(params.availableFunds, 2, GBEUtils.getCurrencySymbol(GBEglobal.currency), true) + "</span>. Would you like to deposit now?";
                break;
            case "restrictedFeature":
                title = "Quick Deposit";
                content = "Hi " + params.username + ", your account balance is <span class='host-moneyamount'>" +
                    GBEUtils.formatDecimal(params.availableFunds, 2, GBEUtils.getCurrencySymbol(GBEglobal.currency), true) + "</span>. Please top up your balance to view this feature.";

                break;

        }

        params.component.setState({
            modalConfig: {
                show: true,
                content: {
                    title: title,
                    body: "<p>" + content + "</p>"
                },
                modalDialogClass: "",
                extraClass: "",
                footerButtons: {
                    Ok: {
                        Text: "Deposit",
                        onClick: function () {
                            params.component.onAccountClicked("ftm/deposit");
                        }
                    },
                    Cancel: {
                        Text: "No Thanks",
                        onClick: function () {
                            params.component.popDialogQueue();
                        }
                    }
                }
            }
        });

    }

    static sanatizeUrl(url) {
        return url.toLowerCase().replace(/[\(.|,)*]/g, "").replace(/@/g, "-v-").replace(/[\\:\s&*]/g, "-").replace(/\-\-/g, "-");
    }

    static getCurrentTime() {
        // Returns current UTC time (local PC time plus offset)
        var currentTime = new Date();
        currentTime.setTime(currentTime.getTime() + GBEglobal.clientTimeOffsetMS);
        return currentTime;
    }

    static isNativeiOS() {
        return (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.javaScriptToSwift);
    }

    static openUrlWithAnchorTag(url, target, hidden) {
        const link = document.createElement("a");
        link.id = "__tmp_tag__";
        link.href = url;
        link.target = target;
        link.hidden = hidden;
        document.body.appendChild(link);
        link.click();
        document.querySelector("#__tmp_tag__").remove();
    }

    static openPopup(url, width, height) {
        const isNativeiOS = this.isNativeiOS();

        width = width || 1060;
        height = height || 430;

        const sParams = "left=" + (screen.width - 730) + ",top=30,width=" + width + ",height=" + height + ",resizable=yes,scrollbars=1";

        if (isNativeiOS) {
            this.openUrlWithAnchorTag(url, "_blank", true);
        } else {
            window.open(url, "_blank", sParams).focus();
        }
    }

    // Returns the currency symbol for a given 3-letter currency code
    static getCurrencySymbol(code) {
        var currencySymbol = "";
        switch (code) {
            case "AUD": currencySymbol = "$"; break;
            case "CAD": currencySymbol = "$"; break;
            case "CEU": currencySymbol = ""; break;
            case "CNY": currencySymbol = "Y"; break;
            case "EUR": currencySymbol = "€"; break;
            case "GBP": currencySymbol = "£"; break;
            case "HKD": currencySymbol = "$"; break;
            case "INR": currencySymbol = "&#x20B9;"; break;
            case "MYR": currencySymbol = "MYR"; break;
            case "PEU": currencySymbol = "€"; break;
            case "PGB": currencySymbol = "£;"; break;
            case "PHP": currencySymbol = "P"; break;
            case "PIN": currencySymbol = "R"; break;
            case "PUS": currencySymbol = "$"; break;
            case "RMB": currencySymbol = "RMB"; break;
            case "RUB": currencySymbol = ""; break;
            case "SGD": currencySymbol = "$"; break;
            case "TWD": currencySymbol = "$"; break;
            case "UAH": currencySymbol = ""; break;
            case "USD": currencySymbol = "$"; break;
            case "THB": currencySymbol = "THB"; break;
        }
        return currencySymbol;
    }

    static SHA256hash(msg, utf8encode) {
        utf8encode = (typeof utf8encode === "undefined") ? true : utf8encode;

        // convert string to UTF-8, as SHA only deals with byte-streams
        if (utf8encode) msg = this.encode(msg);

        // constants [§4.2.2]
        var K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
            0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
            0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
            0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
            0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
            0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
            0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
            0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];

        // initial hash value [§5.3.1]
        var H = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];

        // PREPROCESSING 

        msg += String.fromCharCode(0x80);  // add trailing '1' bit (+ 0's padding) to string [§5.1.1]
        // convert string msg into 512-bit/16-integer blocks arrays of ints [§5.2.1]
        var l = msg.length / 4 + 2;  // length (in 32-bit integers) of msg + ‘1’ + appended length
        var N = Math.ceil(l / 16);   // number of 16-integer-blocks required to hold 'l' ints
        var M = new Array(N);
        for (var i = 0; i < N; i++) {
            M[i] = new Array(16);
            for (var j = 0; j < 16; j++) {  // encode 4 chars per integer, big-endian encoding
                M[i][j] = (msg.charCodeAt(i * 64 + j * 4) << 24) | (msg.charCodeAt(i * 64 + j * 4 + 1) << 16) |
                    (msg.charCodeAt(i * 64 + j * 4 + 2) << 8) | (msg.charCodeAt(i * 64 + j * 4 + 3));
            } // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
        }
        // add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
        // note: most significant word would be (len-1)*8 >>> 32, but since JS converts
        // bitwise-op args to 32 bits, we need to simulate this by arithmetic operators
        M[N - 1][14] = ((msg.length - 1) * 8) / Math.pow(2, 32); M[N - 1][14] = Math.floor(M[N - 1][14])
        M[N - 1][15] = ((msg.length - 1) * 8) & 0xffffffff;
        // HASH COMPUTATION [§6.1.2]

        var W = new Array(64); var a, b, c, d, e, f, g, h;
        for (var i = 0; i < N; i++) {

            // 1 - prepare message schedule 'W'
            for (var t = 0; t < 16; t++) {
                W[t] = M[i][t];
            }
            for (var t = 16; t < 64; t++) W[t] = (this.sigma1(W[t - 2]) + W[t - 7] + this.sigma0(W[t - 15]) + W[t - 16]) & 0xffffffff;

            // 2 - initialise working variables a, b, c, d, e, f, g, h with previous hash value
            a = H[0]; b = H[1]; c = H[2]; d = H[3]; e = H[4]; f = H[5]; g = H[6]; h = H[7];

            // 3 - main loop (note 'addition modulo 2^32')
            for (var t = 0; t < 64; t++) {
                var T1 = h + this.Sigma1(e) + this.Ch(e, f, g) + K[t] + W[t];
                var T2 = this.Sigma0(a) + this.Maj(a, b, c);
                h = g;
                g = f;
                f = e;
                e = (d + T1) & 0xffffffff;
                d = c;
                c = b;
                b = a;
                a = (T1 + T2) & 0xffffffff;
            }
            // 4 - compute the new intermediate hash value (note 'addition modulo 2^32')
            H[0] = (H[0] + a) & 0xffffffff;
            H[1] = (H[1] + b) & 0xffffffff;
            H[2] = (H[2] + c) & 0xffffffff;
            H[3] = (H[3] + d) & 0xffffffff;
            H[4] = (H[4] + e) & 0xffffffff;
            H[5] = (H[5] + f) & 0xffffffff;
            H[6] = (H[6] + g) & 0xffffffff;
            H[7] = (H[7] + h) & 0xffffffff;
        }

        return this.toHexStr(H[0]) + this.toHexStr(H[1]) + this.toHexStr(H[2]) + this.toHexStr(H[3]) +
            this.toHexStr(H[4]) + this.toHexStr(H[5]) + this.toHexStr(H[6]) + this.toHexStr(H[7]);
    }

    static ROTR(n, x) {
        return (x >>> n) | (x << (32 - n));
    }

    static Sigma0(x) {
        return this.ROTR(2, x) ^ this.ROTR(13, x) ^ this.ROTR(22, x);
    }

    static Sigma1(x) {
        return this.ROTR(6, x) ^ this.ROTR(11, x) ^ this.ROTR(25, x);
    }

    static sigma0(x) {
        return this.ROTR(7, x) ^ this.ROTR(18, x) ^ (x >>> 3);
    }

    static sigma1(x) {
        return this.ROTR(17, x) ^ this.ROTR(19, x) ^ (x >>> 10);
    }

    static Ch(x, y, z) {
        return (x & y) ^ (~x & z);
    }

    static Maj(x, y, z) {
        return (x & y) ^ (x & z) ^ (y & z);
    }

    static toHexStr(n) {
        var s = "",
            v;
        for (var i = 7; i >= 0; i--) {
            v = (n >>> (i * 4)) & 0xf; s += v.toString(16);
        }
        return s;
    }

    static encode(strUni) {
        // use regular expressions & String.replace callback function for better efficiency 
        // than procedural approaches
        var strUtf = strUni.replace(
            /[\u0080-\u07ff]/g,  // U+0080 - U+07FF => 2 bytes 110yyyyy, 10zzzzzz
            function (c) {
                var cc = c.charCodeAt(0);
                return String.fromCharCode(0xc0 | cc >> 6, 0x80 | cc & 0x3f);
            }
        );
        strUtf = strUtf.replace(
            /[\u0800-\uffff]/g,  // U+0800 - U+FFFF => 3 bytes 1110xxxx, 10yyyyyy, 10zzzzzz
            function (c) {
                var cc = c.charCodeAt(0);
                return String.fromCharCode(0xe0 | cc >> 12, 0x80 | cc >> 6 & 0x3F, 0x80 | cc & 0x3f);
            }
        );
        return strUtf;
    }

    static randomStr(len) {
        const arr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        var ans = "";
        for (var i = len; i > 0; i--) {
            ans +=
                arr[Math.floor(Math.random() * arr.length)];
        }
        return ans;
    }
}

export default GBETHelper;
